// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HistoryModal_wrapper__1TWSo","sidebar":"HistoryModal_sidebar__3tJdW","header":"HistoryModal_header__1trqt"};